export function formatDate(date) {
  if (!date) return '—';
  return new Date(date).toLocaleDateString('en-IN', {
    day: 'numeric', month: 'short', year: 'numeric',
  });
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount || 0);
}

export function formatFieldValue(field, value, policy = {}) {
  if (value === null || value === undefined || value === '') return '—';
  switch (field.type) {
    case 'currency':
      return formatCurrency(value);
    case 'percent':
      return `${value}%`;
    case 'date':
      return formatDate(value);
    case 'boolean':
      return value ? 'Yes' : 'No';
    case 'select': {
      const opt = field.options?.find((o) => o.value === value);
      return opt?.label || String(value).replace(/_/g, ' ');
    }
    case 'provider':
      return policy.provider_name || '—';
    default:
      return String(value);
  }
}
